import { actionTypes } from '.';

interface I_ItinerariesReq {
    TourID: string;
    GroupID?: string;
    IsPreview: boolean;
    TravelType: number;
}

interface I_OptionalInfoReq {
    GroupID?: string;
}

interface I_NoticeInfoReq {
    GroupID?: string;
}

interface I_PoiReq {
    DayID: number;
    POIID: string;
}

export const setItineraries = (payload: I_ItinerariesReq) => ({
    type: actionTypes.SET_ITINERARIES,
    payload,
});

export const setItinerariesSUCCESS = (payload: any) => ({
    type: actionTypes.SET_ITINERARIES_SUCCESS,
    payload,
});

export const setOptionalInfo = (payload: I_OptionalInfoReq) => ({
    type: actionTypes.SET_OPTIONALINFO,
    payload,
});

export const setOptionalInfoSUCCESS = (payload: any) => ({
    type: actionTypes.SET_OPTIONALINFO_SUCCESS,
    payload,
});

export const setNoticeinfo = (payload: I_NoticeInfoReq) => ({
    type: actionTypes.SET_NOTICEINFO,
    payload,
});

export const setsetNoticeinfoSUCCESS = (payload: any) => ({
    type: actionTypes.SET_NOTICEINFO_SUCCESS,
    payload,
});

export const setPoi = (payload: I_PoiReq) => ({
    type: actionTypes.SET_POI,
    payload,
});

export const setPoiSUCCESS = (payload: any) => ({
    type: actionTypes.SET_POI_SUCCESS,
    payload,
});

export const toggleLightBoxAction = () => ({
    type: actionTypes.TOGGLE_LIGHT_BOX,
});

export const changeSiteInfoAction = (data: any) => ({
    type: actionTypes.CHANGE_SITE_INFO,
    data,
});

export type I_ItinerariesAction = ReturnType<typeof setItineraries>;
export type I_OptionalInfoAction = ReturnType<typeof setOptionalInfo>;
export type I_NoticeinfoAction = ReturnType<typeof setNoticeinfo>;
export type I_PoiAction = ReturnType<typeof setPoi>;
